import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
// Hook to fetch addresses
const useAddresses = () => {
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { user, token } = useSelector((state) => state.auth);

  useEffect(() => {
    const fetchAddresses = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}shipment/userAddresses/`,
            {headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${token.access}`,
              },}
        );
        
        setAddresses(response.data.data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchAddresses();
  }, []);

  return { addresses, loading, error };
};

export default useAddresses;